import { getStoreCNSCInfoById } from 'services/api/store';
import toLowerCase from 'utils/toLowerCase';
import { localeCountryCode } from 'services/chattt';
import {
  lazadaCrossSellerCenterHostMap,
  lazadaSellerCenterHostMap,
  shopeeLocalSellerHostMap,
} from 'services/config/region';
import { openExternalURL } from 'utils/openExternalURL';

export function getOrderSellerCenter(storeId: string, externalTradeId: string) {
  return getStoreCNSCInfoById(storeId).then((res) => {
    const {
      data: {
        storeInfo: { externalType, region, storeType, externalStoreId },
      },
    } = res;

    if (externalType === 'SHOPEE') {
      if (storeType === 'CROSS') {
        openExternalURL(
          `https://seller.shopee.cn/portal/sale/order/${externalTradeId}?cnsc_shop_id=${externalStoreId}`,
          '__blank',
        );
      } else {
        let lcc = 'CN';
        if (localeCountryCode) {
          lcc = localeCountryCode;
        }

        let host = `https://seller.${toLowerCase(region)}.shopee.cn`;
        if (lcc !== 'CN') {
          const r = shopeeLocalSellerHostMap[toLowerCase(region)];
          if (r) {
            host = r;
          }
        }

        openExternalURL(`${host}/portal/sale/order/${externalTradeId}`, '__blank');
      }
    }

    if (externalType === 'LAZADA') {
      let host: string | undefined;

      if (storeType === 'CROSS') {
        host = lazadaCrossSellerCenterHostMap[region];
      } else {
        host = lazadaSellerCenterHostMap[region];
      }

      if (host) {
        openExternalURL(`${host}/apps/order/detail?&tradeOrderId=${externalTradeId}`, '__blank');
      }
    }
  });
}

export const getLazadaRefundAmount = (
  checkedList: string[],
  items: Conversation.Trade.Product[],
) => {
  return checkedList.reduce((res, id) => {
    const target = items.find((_) => {
      const { refundReason: [{ returnOrderItemId = undefined } = {}] = [] } = _;

      return returnOrderItemId === id;
    });

    if (!target) {
      return res;
    }

    return res + ((target.refundReason || [])[0]?.refundAmount || 0);
  }, 0);
};
